import { styled } from '@mui/material/styles'
import { FileCopy } from '@mui/icons-material'

export const StyledCopyIcon = styled(FileCopy)({
  fontSize: 15,
})
